import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "capitalize",
    pure: true,
})
export class CapitalizationPipe implements PipeTransform {

    public transform(input: string): string {
        if (!input) {
            return input;
        }

        let output = input.length === 0 ? "" :
            input.replace(/[A-Za-z0-9-_']+/g,
                (txt) => txt[0].toUpperCase() + txt.substr(1).toLowerCase(),
            );

        output = output.length === 0 ? "" :
            output.replace(/(\W(X{0,3})(IX|IV|V?I{2,3}))+/gi,
                (txt) => txt.toUpperCase(),
            );

        return output;

    }
}
